var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["submissions/components/SubmissionForm/SubmissionFormEpisodesItem.jinja"] = require( "submissions/components/SubmissionForm/SubmissionFormEpisodesItem.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/submissions/components/SubmissionForm/SubmissionFormEpisodes.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionFormEpisodes.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("submissions/components/SubmissionForm/SubmissionFormEpisodesItem.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionFormEpisodes.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "SubmissionFormEpisodesItem")) {
var t_7 = t_4.SubmissionFormEpisodesItem;
} else {
cb(new Error("cannot import 'SubmissionFormEpisodesItem'")); return;
}
context.setVariable("SubmissionFormEpisodesItem", t_7);
output += "\n\n\n";
var macro_t_8 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_9 = "";t_9 += "\n    <div class=\"SubmissionFormEpisodes\">\n\n        <div class=\"SubmissionFormEpisodes-wrapper\">\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"episodes") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"episodes"))) {
t_9 += "\n                ";
frame = frame.push();
var t_12 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"episodes");
if(t_12) {t_12 = runtime.fromIterator(t_12);
var t_11 = t_12.length;
for(var t_10=0; t_10 < t_12.length; t_10++) {
var t_13 = t_12[t_10];
frame.set("item", t_13);
frame.set("loop.index", t_10 + 1);
frame.set("loop.index0", t_10);
frame.set("loop.revindex", t_11 - t_10);
frame.set("loop.revindex0", t_11 - t_10 - 1);
frame.set("loop.first", t_10 === 0);
frame.set("loop.last", t_10 === t_11 - 1);
frame.set("loop.length", t_11);
t_9 += "\n                    ";
t_9 += runtime.suppressValue((lineno = 11, colno = 47, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormEpisodesItem"), "SubmissionFormEpisodesItem", context, [runtime.makeKeywordArgs({"data": t_13,"isRequired": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"first")})])), env.opts.autoescape);
t_9 += "\n                ";
;
}
}
frame = frame.pop();
t_9 += "\n            ";
;
}
else {
t_9 += "\n                ";
t_9 += runtime.suppressValue((lineno = 14, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormEpisodesItem"), "SubmissionFormEpisodesItem", context, [runtime.makeKeywordArgs({"data": {},"isRequired": true})])), env.opts.autoescape);
t_9 += "\n            ";
;
}
t_9 += "\n        </div>\n\n        <div class=\"SubmissionFormEpisodes-footer ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"episodes") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"episodes")) >= 3) {
t_9 += " SubmissionFormEpisodes-footer--hidden";
;
}
t_9 += "\">\n            <div class=\"SubmissionFormEpisodes-add\"><span>+</span><span>Add another episode</span></div>\n            <div class=\"SubmissionFormEpisodes-note\">You can submit 3 episodes in total</div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_9);
});
context.addExport("SubmissionFormEpisodes");
context.setVariable("SubmissionFormEpisodes", macro_t_8);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/submissions/components/SubmissionForm/SubmissionFormEpisodes.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormEpisodes.jinja
// module id = 55
// module chunks = 0